import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { unitPrice } from "@/lib/api";

const CartContext = createContext(null);
const KEY = "gamerealm_cart";
const OLD_KEY = "nexuskeys_cart";
const MAX_QTY = 1000;
const cap = (i) => Math.min(MAX_QTY, i.oversell ? MAX_QTY : i.stock);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || localStorage.getItem(OLD_KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); localStorage.removeItem(OLD_KEY); }, [items]);

  const value = useMemo(() => {
    const add = (game, qty = 1) => setItems((prev) => {
      const fresh = { id: game.id, name: game.name, platform: game.platform, kind: game.kind, codes: game.codes, price: game.price, stock: game.stock,
        bulk_tiers: game.bulk_tiers || [], oversell: game.oversell };
      const found = prev.find((i) => i.id === game.id);
      if (found) return prev.map((i) => (i.id === game.id ? { ...i, ...fresh, qty: Math.min(i.qty + qty, cap(fresh)) } : i));
      return [...prev, { ...fresh, qty: Math.min(qty, cap(fresh)) }];
    });
    const setQty = (id, qty) => setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty: Math.max(1, Math.min(qty || 1, cap(i))) } : i)));
    const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.qty, 0);
    const total = items.reduce((s, i) => s + i.qty * unitPrice(i, i.qty), 0);
    return { items, add, setQty, remove, clear, count, total, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
